/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CardCheckResponse = {
    status: CardCheckResponse.status;
    message?: string;
    ok: boolean;
}

export namespace CardCheckResponse {

    export enum status {
        '_200' = 200,
        '_401' = 401,
        '_403' = 403,
        '_410' = 410,
        '_418' = 418,
        '_451' = 451,
    }


}
